import { useState } from 'react';
import {
  required,
  Button,
  TextInput,
  FormWithRedirect,
  useUpdate,
  useNotify,
  useRedirect,
  useRefresh
} from 'react-admin';
import IconCancel from '@material-ui/icons/Cancel';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import GppBadIcon from '@mui/icons-material/GppBad';

const DeleteDriverButton: React.FC = (props: any) => {
  const [showDialog, setShowDialog] = useState(false);
  const [update, { loading }] = useUpdate();
  const notify = useNotify();
  const redirectTo = useRedirect();
  const refresh = useRefresh();
  const handleClick = () => {
    setShowDialog(true);
  };

  const handleCloseClick = () => {
    setShowDialog(false);
  };

  const handleSubmit = async (values: any) => {
    values.active = false
    update('drivers', props.record.id, values, props.record, {
      onSuccess: () => {
        setShowDialog(false);
        notify('Driver deactivated', 'info', undefined, false, 3000);
        redirectTo(`/drivers/${props.record.id}/show`, props.basePath);
        setTimeout(()=> {refresh(true)}, 1500);
      },
      onFailure: ({ error }) => {
        notify(error.message, 'error');
      }
    })
  };

  return (
    <>
      <Button onClick={handleClick} label="Deactivate" style={{color: 'red'}}>
        <GppBadIcon sx={{ color: 'red' }}/>
      </Button>
      <Dialog
        fullWidth
        open={showDialog}
        onClose={handleCloseClick}
        aria-label="Create post"
      >
        <DialogTitle>Deactivation reason</DialogTitle>

        <FormWithRedirect
          {...props}
          resource="drivers"
          save={handleSubmit}
          render={({
            handleSubmitWithRedirect,
          }) => (
            <>
              <DialogContent>
                <TextInput
                  source="deactivation_reason"
                  validate={required()}
                  fullWidth
                  multiline
                />
              </DialogContent>
              <DialogActions style={{justifyContent: 'space-between'}}>
                <Button
                  label="ra.action.cancel"
                  onClick={handleCloseClick}
                  disabled={loading}
                >
                  <IconCancel />
                </Button>
                
                <Button
                  label="Deactivate"
                  disabled={loading}
                  onClick={() => handleSubmitWithRedirect!()}
                  style={{color: 'red'}}
                >
                  <GppBadIcon sx={{ color: 'red' }}/>
                </Button>
                
              </DialogActions>
            </>
          )}
        />
      </Dialog>
    </>
  );
}

export default DeleteDriverButton;

